import { useState } from 'react';
import { Link } from 'react-router-dom';
import { WHATSAPP_URL, PRICING_WHATSAPP_URL } from '../../config/contact';
import './Footer.css';

const FOOTER_LINKS = {
  Product: [
    { label: 'WhatsApp Automation', href: '/features#whatsapp' },
    { label: 'AI Email Assistant',  href: '/features#email' },
    { label: 'Shopify Integration',  href: '/features#ecommerce' },
    { label: 'WooCommerce',          href: '/features#ecommerce' },
    { label: 'LeadFlow Pipeline',    href: '/features#leadflow' },
    { label: 'Broadcast Campaigns',  href: '/features#whatsapp' },
    { label: 'AI Knowledge Base',    href: '/features#whatsapp' },
  ],
  Solutions: [
    { label: 'E-Commerce Stores',    href: '/solutions#ecommerce' },
    { label: 'Healthcare & Clinics', href: '/solutions#healthcare' },
    { label: 'Real Estate',          href: '/solutions#realestate' },
    { label: 'Education & Coaching', href: '/solutions#education' },
    { label: 'Travel & Hospitality', href: '/solutions#travel' },
    { label: 'Marketing Agencies',   href: '/solutions#agencies' },
    { label: 'SaaS & Tech',          href: '/solutions#saas' },
  ],
  Resources: [
    { label: 'Documentation',   href: '/docs' },
    { label: 'Blog & Guides',   href: '/blog' },
    { label: 'API Reference',   href: '/docs' },
    { label: 'Changelog',       href: '/changelog' },
    { label: 'System Status',   href: '/status' },
    { label: 'Video Tutorials', href: '/tutorials' },
  ],
  Company: [
    { label: 'About Zepliq',    href: '/about' },
    { label: 'Careers',         href: '/careers' },
    { label: 'Partners Program', href: '/partners' },
    { label: 'Press Kit',       href: '/press' },
    { label: 'Contact Us',      href: '/contact' },
    { label: 'Privacy Policy',  href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
  ],
};

const SOCIALS = [
  {
    label: 'WhatsApp', href: WHATSAPP_URL,
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>,
  },
  {
    label: 'LinkedIn', href: 'https://www.linkedin.com/company/zepliq/',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  },
  {
    label: 'YouTube', href: 'https://www.youtube.com/@zepliq_ai',
    icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  },
];


export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) setSubscribed(true);
  };

  return (
    <footer className="footer">
      {/* Ambient glow */}
      <div className="footer__glow" aria-hidden="true" />

      {/* ── CTA STRIP ── */}
      <div className="footer__cta-strip">
        <div className="container footer__cta-inner">
          <div className="footer__cta-content">
            <h2 className="display-md footer__cta-title">
              Ready to automate?<br />
              <span className="gradient-text">Go live in 5 minutes.</span>
            </h2>
            <p className="footer__cta-sub">
              No API approvals. No developers. Just scan, train, and launch.
            </p>
          </div>
          <div className="footer__cta-actions">
            <Link to="/contact" className="btn btn-primary btn-lg">
              Start Free
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
            <a href={PRICING_WHATSAPP_URL} className="btn btn-secondary btn-lg" target="_blank" rel="noopener noreferrer">Get Pricing on WhatsApp</a>
          </div>
        </div>
      </div>

      {/* ── MAIN FOOTER ── */}
      <div className="footer__main">
        <div className="container">
          <div className="footer__grid">

            {/* Brand column */}
            <div className="footer__brand">

              <Link to="/" className="footer__logo">
                <img src="/logo.svg" alt="Zepliq logo" className="footer__logo-img" />
                <span className="footer__logo-text">Zepliq</span>
              </Link>

              <p className="footer__tagline">
                AI automation for WhatsApp, Email, Shopify, and WooCommerce.
                One platform. Every channel.
              </p>

              {/* Newsletter */}
              <div className="footer__newsletter">
                <p className="footer__newsletter-label">Stay in the loop</p>
                {subscribed ? (
                  <div className="footer__newsletter-thanks">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="10" fill="rgba(99,102,241,0.15)"/>
                      <path d="M6 10l3 3 5-5" stroke="var(--brand-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    You're subscribed!
                  </div>
                ) : (
                  <form className="footer__newsletter-form" onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      className="footer__newsletter-input"
                      placeholder="your@email.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      required
                    />
                    <button type="submit" className="footer__newsletter-btn" aria-label="Subscribe">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </button>
                  </form>
                )}
              </div>

              {/* Socials */}
              <div className="footer__socials">
                {SOCIALS.map(s => (
                  <a key={s.label} href={s.href} className="footer__social" aria-label={s.label} target="_blank" rel="noopener noreferrer">
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Link columns */}
            {Object.entries(FOOTER_LINKS).map(([section, links]) => (
              <div key={section} className="footer__col">
                <h3 className="footer__col-title">{section}</h3>
                <ul className="footer__col-links">
                  {links.map(link => (
                    <li key={link.label}>
                      <Link to={link.href} className="footer__col-link">{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="footer__divider" />
          <div className="footer__bottom">
            <p className="footer__copy">© {new Date().getFullYear()} Zepliq Inc. All rights reserved.</p>
            <div className="footer__bottom-links">
              <Link to="/privacy" className="footer__bottom-link">Privacy</Link>
              <span className="footer__bottom-dot" />
              <Link to="/terms" className="footer__bottom-link">Terms</Link>
              <span className="footer__bottom-dot" />
              <Link to="/privacy" className="footer__bottom-link">Cookies</Link>
            </div>
            <p className="footer__made">Built for businesses worldwide</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
